import React from "react";

const WIDTH = 150;
const HEIGHT = 75;

function ContextMenu({ id, x, y, onAdd, onEdit, onCollapse }) {
  return (
    <g transform={`translate(${x - WIDTH * 0.5},${y + 20})`}>
      <rect
        x={0}
        y={0}
        width={WIDTH}
        height={HEIGHT}
        fill="white"
        stroke="black"
        strokeWidth={1}
      />
      <g transform={`translate(${WIDTH * 0.5},0)`}>
        <line x1="-10" y1="0" x2="10" y2="0" stroke="white" strokeWidth={3} />
        <polyline
          points="-10,0 0,-10 10,0"
          fill="none"
          stroke="black"
          strokeWidth={1}
        />
      </g>
      <text
        x={WIDTH * 0.1}
        y={20}
        className="clickable"
        fontSize={14}
        onClick={e => onAdd(id)}
      >
        Add new entity
      </text>
      <text
        x={WIDTH * 0.1}
        y={40}
        className="clickable"
        fontSize={14}
        onClick={e => onEdit(id)}
      >
        Edit
      </text>
      {/* <text x={WIDTH * 0.1} y={60} fontSize={14} onClick={e => onCollapse(id)}>
         Collapse/Expand
       </text> */}
    </g>
  );
}

export default ContextMenu;
